import { Account, AccountMapping, AccountMappingHead, NewAccountMapping } from '@/types/account-mapping-api';
import { api, withErrorHandling } from './api';

export const getAccountMappingHeads = async (clientId: string): Promise<Array<AccountMappingHead>> => {
    console.log('Fetching account mapping heads:');
    const response = await withErrorHandling(() => api.get<Array<AccountMappingHead>>(`/clients/${clientId}/account-mappings`));
    console.log('Account mappings response:', response.data);
    return response.data;
};

export const createAccountMapping = async (accountMapping: NewAccountMapping): Promise<AccountMapping> => {
    console.log('Creating account mapping:', accountMapping);
    const response = await withErrorHandling(() => api.post<AccountMapping>("/mappings/account", accountMapping));
    console.log('Create liquidity scenario response:', response.data);
    return response.data;
};

export const getAccountMapping = async (accountMappingId: string): Promise<AccountMapping> => {
    console.log('Fetching account mapping:', accountMappingId);
    const response = await withErrorHandling(() => api.get<AccountMapping>(`/mappings/account/${accountMappingId}`));
    console.log('Account mapping response:', response.data);
    return response.data;
}

export const putAccountMapping = async (accountMapping: AccountMapping): Promise<AccountMapping> => {
    console.log('Updating account mapping:', accountMapping);
    const response = await withErrorHandling(() => api.put<AccountMapping>(`/mappings/account/${accountMapping.id}`, accountMapping));
    console.log('Update account mapping response:', response.data);
    return response.data;
}

export const getAccounts = async (clientId: string): Promise<Array<Account>> => {
    console.log('Fetching accounts:', clientId);
    const response = await withErrorHandling(() => api.get<Array<Account>>(`/clients/${clientId}/accounts`));
    console.log('Accounts response:', response.data);
    return response.data;
}

export const deleteAccountMapping = async (accountMappingId: string): Promise<void> => {
    console.log('Deleting account mapping:', accountMappingId);
    await withErrorHandling(() => api.delete(`/mappings/account/${accountMappingId}`));
    console.log('Account mapping deleted');
}

export const putAccountMappingName = async (accountMappingId: string, name: string): Promise<AccountMapping> => {
    console.log('Updating account mapping name:', accountMappingId, name);
    const response = await withErrorHandling(() => api.put<AccountMapping>(`/mappings/account/${accountMappingId}/name`, JSON.stringify(name)));
    console.log('Update account mapping name response:', response.data);
    return response.data;
}

export const postPublishAccountMappings = async (clientId: string): Promise<void> => {
    console.log('Publishing account mappings for client:', clientId);
    await withErrorHandling(() => api.post(`clients/${clientId}/account-mappings/publish`));
    console.log('Account mappings published');
}